'use client';

import { LogOut } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { signOut } from "firebase/auth";
import { useFirebase } from '@/firebase/provider';

export function LogoutButton() {
    const { toast } = useToast();
    const { auth } = useFirebase();

    const handleLogout = async () => {
        if (!auth) {
            console.error("Firebase auth not available");
            toast({
                title: "Logout Failed",
                description: "Could not connect to authentication service.",
                variant: "destructive",
            });
            return;
        }
        try {
            await signOut(auth);
            
            // Clear the session ID from localStorage
            localStorage.removeItem('sessionId');

            toast({
                title: "Logged Out",
                description: "You have been successfully logged out.",
                variant: "info",
            });
            // Full page reload to clear context and state
            window.location.href = '/'; 
        } catch (error) {
            console.error("Logout Error: ", error);
            toast({
                title: "Logout Failed",
                description: "Something went wrong. Please try again.",
                variant: "destructive",
            });
        }
    };

    return (
        <button
            onClick={handleLogout}
            className="flex w-full items-center text-destructive focus:bg-destructive/10 focus:text-destructive cursor-pointer p-2 rounded-md text-sm"
        >
            <LogOut className="mr-2 h-4 w-4" />
            <span>Log out</span>
        </button>
    );
}
